import { mapMutations, mapState, mapGetters } from 'vuex'

window.mixins = {
    data () {
        return {
            bottomFixedStyle :{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0
            },

            leftMarginForFixed: 0
        }
    },
    computed: {
      ...mapState({
        user: state => state.auth.user
      }),

      ...mapGetters('common', ['isVirtual']),

    },

    created () {
        this.resetToolbarButtons()
    },

    mounted () {
        this.changeBottomFixedStyle()
        this.leftMarginForFixed = this.bottomFixedStyle.left

        window.addEventListener('resize', () => {
            this.changeBottomFixedStyle()
            this.leftMarginForFixed = this.bottomFixedStyle.left
        })
    },

    methods: {
        ...mapMutations([
            'setParent',
            'setTitle',
            'addToolbarButton',
            'resetToolbarButtons',
        ]),

        changeNavbar () {
            this.setTitle(this.$route.name)
            this.setParent(this.parent)
        },

        save (key, value) {
            sessionStorage.setItem(this.$route.path + '.' + key, JSON.stringify(value))
        },

        load (key) {
            return JSON.parse(sessionStorage.getItem(this.$route.path + '.' + key))
        },

        savePersistent (key, value) {
            localStorage.setItem(this.$route.path + '.' + key, JSON.stringify(value))
        },

        loadPersistent (key) {
            return JSON.parse(localStorage.getItem(this.$route.path + '.' + key))
        },
        performLogin() {
          this.$store.commit('auth/setRedirectUrl', this.$route.path)
          this.$router.push('/login').catch(err => {
            if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') throw err
          })
          return false
        },
        checkLogin () {
            if (this.login == 0) return true;
            if (this.user === null) {
              return this.performLogin()
            }

            return true
        },

        getContentWidth () {
            let content = document.getElementsByClassName('v-main__wrap')[0]
            return content.offsetWidth
        },

        changeBottomFixedStyle () {
            let nav = document.getElementsByTagName('nav')[0]
            if (nav) {
                if (!nav.classList.contains('v-navigation-drawer--is-mobile') && nav.classList.contains('v-navigation-drawer--open')) {
                    this.bottomFixedStyle.left = nav.offsetWidth + 'px'
                } else {
                    this.bottomFixedStyle.left = 0
                }
            }

            if (this.isVirtual) {
              this.bottomFixedStyle.position = 'sticky'
            }

            // modern design: keep bottom bars above the floating tab bar
            if (document.querySelector('.ee-modern')) {
                this.bottomFixedStyle.bottom = 'calc(var(--tabbar-h) + var(--safe-b) + 20px)'
                this.bottomFixedStyle.left = 0
            }
        }
    }
}
